/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { ReportService } from '../../../services/report/report.service';
import { IceTypes } from '../../icetypes';
import { report, reportDataField, reportCompanyField, reportCustomField, Report_Mode_Type, Command_Type, ReportSelectionType, Report_Layout_Type, reportSystemData, Report_Orientation, Report_Page_Sizes, reportObject, ReportSectionTypes, reportSection, ReportObjectType, reportField, reportSystemField, reportFormulaField, reportSummationField } from '../report';
import { reportfilter } from '../subs/reportfilter';
import { reportdata } from '../reportdata';
import { reporttemplate } from '../reporttemplate';
import { Iceutility } from '../../../services/iceutility';
import { IceRect } from '../../../components/icemultimedia/IceMultimediaStroke';

export class basereportprocess extends IceEntity {
  private parentReport: report = null; // Parent Report
  private reportTemplates: report[] = []; // Template Reports to Render (Design, Print, Preview)
  private currentTemplateReference: reporttemplate = null; // Reference record to Template Report
  private repData: reportdata = null;

  baseFields: string[] = [];
  mapBaseUserNames: any = {};
  mapBaseColumnNames: any = {};

  customFields: string[] = [];
  mapCustomUserNames: any = {};
  mapCustomColumnNames: any = {};;

  commandType: Command_Type = Command_Type.cmdtNewReport;
  modeType: Report_Mode_Type = Report_Mode_Type.modeDesign;
  selectionType: ReportSelectionType = ReportSelectionType.reportInternalSelection;

  reportName: string = "";
  reportKey: string = "";
  reportDataFile: string = "";

  selection_fields: reportDataField[] = [];
  selection_tables: string[] = [];
  company_selection_fields: any[] = [];
  custom_selection_fields: any[] = [];

  // fields and object arrays
  sections: reportSection[] = []; //same as outputSections
  formula_fields: reportFormulaField[] = [];
  //report_data_fields: string[] = []; same as outputColumns
  report_company_fields: string[] = [];
  summation_fields: reportSummationField[] = [];
  filters: reportfilter[] = [];

  records: string[][] = [];

  company_record: string[] = [];
  records_temp: string[] = [];
  system_data: reportSystemData = null;

  repLayoutType: Report_Layout_Type = Report_Layout_Type.rltSectionLayout;

  c_lnUnRealizedPixelPerInch: number = basereportprocess.pixelsPerInch();
  c_dblUnRealizedScale: number = 1.0;
  c_dblDEFAULTCELL_Y: number = 0.25;
  c_dblDEFAULTPADDING_Y: number = (this.c_dblDEFAULTCELL_Y / 2.0) + 0.0625;
  c_dblMM_TO_INCH: number = 0.0394;
  c_dblINCH_TO_MM: number = 25.4;
  c_dblFontPointsPerInch: number = 72;

  width: number = 8.5;
  height: number = 11.0;
  pageSizeType: Report_Page_Sizes = Report_Page_Sizes.ps8_5_by_11;
  orientation: Report_Orientation = Report_Orientation.orPortrait;
  rcMargins: IceRect = new IceRect(this.c_lnUnRealizedPixelPerInch, this.c_lnUnRealizedPixelPerInch, this.c_lnUnRealizedPixelPerInch, this.c_lnUnRealizedPixelPerInch);
  dontAllowChange: boolean = false;
  oneRecordPerPage: boolean = false;

  sysdata: reportSystemData = null;
  //outputSections: any = {};
  outputColumnDefinitions: any = {};
  outputColumns: string[] = [];
  outputRecords: Array<Array<any>> = [];

  outputSumFields: reportSummationField[] = [];
  outputFormulaFields: reportFormulaField[] = [];
  outputCompanyFields: reportCompanyField[] = [];

  static pixelsPerInch: Function = () => {
    const el: HTMLElement = document.createElement('div');
    el.style.width = 'width: 1in;'
    document.body.appendChild(el);
    const dpi = el.offsetWidth;
    document.body.removeChild(el);
    return dpi;
  }

  static inch2Pix: Function = (inches: number, perinch: number, scale: number): number => {
    if (scale == 0.0)
      scale = 1.0;

    let pixels = inches * (perinch * scale);
    return pixels;
  };

  static pix2Inch: Function = (pixels: number, perinch: number, scale: number): number => {
    if (scale == 0.0)
      scale = 1.0;

    let inches: number = pixels / (perinch * scale);
    return inches;
  };

  static getSectionNameByType(type: ReportSectionTypes): string {
    let ret: string = "";
    switch (type) {
      case ReportSectionTypes.secReportHeader:
        return "Report Header";
      case ReportSectionTypes.secPageHeader:
        return "Page Header";
      case ReportSectionTypes.secSortHeader1:
        return "Sort Header 1";
      case ReportSectionTypes.secSortHeader2:
        return "Sort Header 2";
      case ReportSectionTypes.secSortHeader3:
        return "Sort Header 3";
      case ReportSectionTypes.secDetail:
        return "Detail";
      case ReportSectionTypes.secSortFooter1:
        return "Sort Footer 1";
      case ReportSectionTypes.secSortFooter2:
        return "Sort Footer 2";
      case ReportSectionTypes.secSortFooter3:
        return "Sort Footer 3";
      case ReportSectionTypes.secPageFooter:
        return "Page Footer";
      case ReportSectionTypes.secReportFooter:
        return "Report Footer";
    }
    return ret;
  }

  constructor(repSvc: ReportService, parentRpt: report, templates: report[], curTemplateReference: reporttemplate, data: reportdata) {
    super();

    this.sections.push(new reportSection({ "SECTION": "Report Header", "SHOW": "1" }));
    this.sections.push(new reportSection({ "SECTION": "Page Header", "SHOW": "1" }));
    this.sections.push(new reportSection({ "SECTION": "Sort Header 1", "SHOW": "0" }));
    this.sections.push(new reportSection({ "SECTION": "Sort Header 2", "SHOW": "0" }));
    this.sections.push(new reportSection({ "SECTION": "Sort Header 3", "SHOW": "0" }));
    this.sections.push(new reportSection({ "SECTION": "Detail", "SHOW": "1" }));
    this.sections.push(new reportSection({ "SECTION": "Sort Footer 1", "SHOW": "0" }));
    this.sections.push(new reportSection({ "SECTION": "Sort Footer 2", "SHOW": "0" }));
    this.sections.push(new reportSection({ "SECTION": "Sort Footer 3", "SHOW": "0" }));
    this.sections.push(new reportSection({ "SECTION": "Page Footer", "SHOW": "1" }));
    this.sections.push(new reportSection({ "SECTION": "Report Footer", "SHOW": "1" }));

    this.reportName = "";
    this.reportKey = "";
    this.modeType = Report_Mode_Type.modePreview;
    this.commandType = Command_Type.cmdtOpenReport;
    this.selectionType = ReportSelectionType.reportInternalSelection;
    this.system_data = new reportSystemData();

    this.parentReport = parentRpt;
    this.reportTemplates = templates;
    this.currentTemplateReference = curTemplateReference;
    this.repData = data;
  }

  getParentReport(): report { return this.parentReport; }
  getReportTemplates(): report[] { return this.reportTemplates; }
  getCurrentReportTemplateReference() { return this.currentTemplateReference; }
  getReportData(): reportdata { return this.repData; }

  setCommandType(cmdType: Command_Type): void { this.commandType = cmdType; }
  setModeType(mType: Report_Mode_Type) { this.modeType = mType; }
  setSelectionType(sType: ReportSelectionType) { this.selectionType = sType; }
  setReportDataFile(sfile: string) { this.reportDataFile = sfile; }

  getCommandType(): Command_Type { return this.commandType; }
  getModeType(): Report_Mode_Type { return this.modeType; }
  getSelectionType(): ReportSelectionType { return this.selectionType; }
  getReportDataFile(): string { return this.reportDataFile; }

  getReportName(): string { return this.reportName; }
  setReportName(rptName: string) { this.reportName = rptName; }
  getReportKey(): string { return this.reportKey; }

  setDontAllowChange(dontAllowChge: boolean): void { this.dontAllowChange = dontAllowChge; }
  getDontAllowChange(): boolean { return this.dontAllowChange; }

  setOneRecordPerPage(oneRecordPP): void { this.oneRecordPerPage = oneRecordPP; }
  getOneRecordPerPage(): boolean { return this.oneRecordPerPage };

  create(mode: Report_Mode_Type, command: Command_Type, reportKey: string, reportFile: string): boolean {
    debugger;
    let reportImportPathName = this.getReportDataFile();

    this.commandType = command;
    this.modeType = mode;
    //let customRecordIndex = -1;

    if (Command_Type.cmdtNewReport == this.commandType) {
      if (ReportSelectionType.reportInternalSelection == this.getSelectionType())
      {
        /*
        CReportSelectionDialog dlg(dynamic_cast < CWnd *> (pFrame));
        dlg.m_pRW = this;
        CCustomDataRecord * pCustRec = NULL;
        OnGetSelectionReport(dlg.m_reports, & dlg.customRecord);
        if (dlg.DoModal() == IDOK) {
          if (IsCoordinateReport(dlg.m_strReportName)) {
            // Removed after we started using Print Jobs
            //pFrame->SendMessage(WM_CLOSE);
            long nMode = modePreview;
            if (modeDesign != dlg.GetModeType())
              nMode = dlg.GetModeType();

            InternalPrintCoordinateReport(nMode, dlg.m_strReportName);
            strReportFile = dlg.m_strReportName;
            strReportKey = dlg.GetReportKey();
            return TRUE;
          }

          m_nModeType = dlg.GetModeType();
          m_nCommandType = dlg.GetCommandType();
          customRecordIndex = dlg.GetCustomRecordIndex();
          if (cmdtOpenReport == m_nCommandType) {
            strReportFile = dlg.m_strReportName;
            strReportKey = dlg.GetReportKey();
          }
        }
        else {
          pFrame -> SendMessage(WM_CLOSE);
          return FALSE;
        }
        */
      }
      else if (ReportSelectionType.reportFileSelection == this.getSelectionType() && (reportKey == null || reportKey.length == 0)) {
        /*
        if (reportImportPathName.IsEmpty()) {
          // Change to 
          CFileDialog fileDlg(TRUE,
            _T("*.xml"),
            NULL,
            OFN_HIDEREADONLY | OFN_OVERWRITEPROMPT,
            ReportFileExtensionFilters(), AfxGetMainWnd());
          if (fileDlg.DoModal() == IDOK) {
            reportFile = fileDlg.GetPathName();
          }
        }
        else {
          reportFile = reportImportPathName;
        }
        */
      }
    }

    // open command
    switch (this.commandType) {
      case Command_Type.cmdtOpenReport:
        {
          this.initializeSelectionFields();
          this.initializeReport();

          if (this.onOpen(reportKey, reportFile) == false) {
            return false;
          }

          if (Iceutility.isStringUndefinedNullOrEmpty(reportFile)) reportFile = this.getReportName();

          // call this because the default is portrait
          //if (GetOrientation() == orLandscape)
            //pDoc->DoDocumentWidthChange();

          if (Report_Mode_Type.modeDesign == this.modeType) {
            //pDoc->LoadFromSectionData();
          }

          break;
        }
      case Command_Type.cmdtNewReport:
        {
          /*
          if (Iceutility.isStringUndefinedNullOrEmpty(reportFile)) {
            CReportNameDialog dlg(dynamic_cast < CWnd *> (pFrame));
            dlg.SetReportName("Untitled");
            if (dlg.DoModal() == IDCANCEL) {
              pFrame -> SendMessage(WM_CLOSE);
              return FALSE;
            }

            if (strReportKey.IsEmpty()) {
              strReportFile = dlg.GetReportName();
              strReportFile + ".rwx"; // change to a vir function
              // report already exist
              BOOL bReportExist = DoesReportExist(strReportFile);
              if (bReportExist) {
						    :: MessageBox(pFrame -> m_hWnd, _T("Report already exist!"), _T("New Report"), MB_OK);
                pFrame -> SendMessage(WM_CLOSE);
                return FALSE;
              }
            }
          }
          */

          if (this.onNew(reportKey, reportFile) == false) {
            return false;
          }

          //ResetSelectionFields();
          //InitializeSelectionFields();
          break;
        }
      default:
        {
          return false;
        }
    }

    let results = true;
    switch (this.modeType) {
      case Report_Mode_Type.modeDesign:
      case Report_Mode_Type.modePreview:
        {
          /*
          CRect rect;
          rect.bottom = :: GetSystemMetrics(SM_CYSCREEN) / 3;
          rect.right = :: GetSystemMetrics(SM_CXSCREEN) / 3;
          rect.top = 0;
          rect.left = 0;

          pFrame -> MoveWindow(& rect);
          pFrame -> ShowWindow(SW_SHOWMAXIMIZED);

          if (m_nModeType == modeDesign) {
            pDoc -> DoDesign();
          }
          else {
            SetAutoClose();
            pDoc -> DoPreview();
          }
          */
          results = false;
          break;
        }
      case Report_Mode_Type.modePrint: {
        //SetAutoClose();
        //pFrame -> ShowWindow(SW_HIDE);
        //pDoc -> DoPrint();
        break;
      }
    }

    //pDoc -> SetTitle(strReportFile);
    return results;
  }

  initializeSelectionFields(): void {
    if (this.selection_fields.length == 0) {
      let fieldIndex = 0;

      // get all fields to select from 
      while (true || fieldIndex < 50) {
        let field = this.onGetSelectionField(fieldIndex);
        if (field == null) break;
        if (Iceutility.isStringUndefinedNullOrEmpty(field.getColumnName()) || Iceutility.isStringUndefinedNullOrEmpty(field.getTableName()))
          continue;

        this.selection_fields.push(field);
        fieldIndex++;
      }
    }

    if (this.company_selection_fields.length == 0) {
      let fieldIndex = 0;

      // get all fields to select from 
      while (true || fieldIndex < 25) {
        let field = this.onGetCompanySelectionField(fieldIndex);
        if (field == null) break;
        if (Iceutility.isStringUndefinedNullOrEmpty(field.getColumnName()) || Iceutility.isStringUndefinedNullOrEmpty(field.getTableName()))
          continue;

        this.company_selection_fields.push(field);
        fieldIndex++;
      }
    }

    if (this.custom_selection_fields.length == 0) {
      let fieldIndex = 0;

      // get all fields to select from 
      while (true || fieldIndex < 50) {
        let field = this.onGetCustomSelectionField(fieldIndex);
        if (field == null) break;
        if (Iceutility.isStringUndefinedNullOrEmpty(field.getColumnName()) || Iceutility.isStringUndefinedNullOrEmpty(field.getTableName()))
          continue;

        this.custom_selection_fields.push(field);

        fieldIndex++;
      }
    }
  }

  initializeReport(): void {
    this.sysdata = new reportSystemData();
    this.outputColumnDefinitions = {};
    this.outputColumns = [];
    this.outputRecords = [];

    // get fields in report
    for (let ifld = 0; ifld < this.selection_fields.length; ifld++) {
      let obj = this.selection_fields[ifld];
      if (obj != null) {
        this.outputColumns.push(obj.getFullName());
      }
    }

    for (let isec = ReportSectionTypes.secReportHeader; isec <= ReportSectionTypes.secReportFooter; isec++) {
      let section = this.getSection(isec);
      if (section != null) {
        for (let i = 0; i < section.getObjectCount(); i++) {
          let obj = section.getObject(i);
          if (obj) {
            if (ReportObjectType.otCompanyField == reportSection.getObjectType(obj)) {
              let fld = <reportCompanyField>obj;
              this.report_company_fields.push(fld.getFullName());
            }
          }
        }
      }
    }

    for (let iformula = 0; iformula < this.formula_fields.length; iformula++) {
      let formulaField = this.getFormula(iformula);
      if (formulaField != null) {
        let sFormula = formulaField.getFormula();
        let npos_start = -1;
        /*
        CString strTableColumnName;
        while (GetFieldInText(strFormula, npos_start, strTableColumnName)) {
          m_report_data_fields.SetAtGrow(m_report_data_fields.GetSize(), strTableColumnName);
        }
        */
      }
    }

    for (let isum = 0; isum < this.summation_fields.length; isum++) {
      let sumField = this.getSumField(isum);
      if (sumField != null) {
        let sSumColumnName = reportDataField.parseColumnName(sumField.getFullName());

        // locate selection field 
        for (let isel = 0; isel < this.selection_fields.length; isel++) {
          let fld = this.selection_fields[isel];
          if (fld != null) {
            let sSelColumnName = reportDataField.parseColumnName(fld.getFullName());
            if (sSelColumnName.toLowerCase() == sSumColumnName.toLowerCase()) {
              sumField.setDataType(fld.getDataType());
              break;
            }
          }
        }

        // reset values
        sumField.setHeaderValue(0);
        sumField.setDetailValue(0);
        sumField.setFooterValue(0);
        this.outputColumns.push(sumField.getFullName());
      }
    }
  }

  onProcessReport(): report {
    debugger;
    if (this.currentTemplateReference == null || this.reportTemplates == null || this.reportTemplates.length == 0) return null;

    let fndRep = this.reportTemplates.filter(t => t.report_key == this.currentTemplateReference.template_report_key);
    if (fndRep.length == 0) return null;

    this.initializeSelectionFields();

    // lookup company record
    this.company_record = this.onQueryCompanyRecord(this.report_company_fields);

    this.outputRecords = this.onQueryRecord(this.outputColumns, this.filters, true);
    if (this.outputRecords != null && this.outputRecords.length > 0) {
      return fndRep[0];
    }

    return null;
  }

  addSelectionTable(sTable: string): void {
    this.selection_tables.push(sTable);
  }

  getReportFieldIndex(tableColumn: string): number {
    // selection fields
    let ret = this.outputColumnDefinitions[tableColumn];
    if (ret == null) return -1;
    return ret;
  }

  ///////////////////////////
  // Section Members
  getSectionByName(name: string): reportSection {
    if (name == null || name.length == 0) return null;
    for (let isec = 0; isec < this.sections.length; isec++) {
      let sec = this.sections[isec];
      if (sec == null) continue;

      let secName = sec.getSectionName();
      if (secName != null && secName.toLowerCase() == name.toLowerCase()) {
        return sec;
      }
    }
    return null;
  }

  getSectionByType(type: ReportSectionTypes): reportSection {
    return this.getSectionByName(basereportprocess.getSectionNameByType(type));
  }

  getSection(index: number): reportSection {
    if (index >= this.sections.length || index < 0)
      return null;

    return this.sections[index];
  }

  getSectionType(sec: reportSection): ReportSectionTypes {
    let ret = ReportSectionTypes.secNone;
    for (let isec = 0; isec < this.sections.length; isec++)
    {
      let obj = this.sections[isec];
      if (obj == sec )
      {
        return isec;
      }
    }
    return -1;
  }

  /////////////////////////
  // Formula Members
  getFormula(index: number): reportFormulaField {
    if (index >= 0 && index < this.formula_fields.length) {
      return this.formula_fields[index];
    }
    return null;
  }

  gtFormulaIndex(formulaName: string): number {
    // formula fields
    for (let ifld = 0; ifld < this.formula_fields.length; ifld++)
    {
      let fld = this.formula_fields[ifld];
      if (fld != null) {
        let text: string = fld.getColumnName();
        if (text.toLowerCase() == formulaName.toLowerCase()) {
          return ifld;
        }
      }
    }
    return -1;
  }

  /*
  BOOL CReportWriter:: GetFieldInText(CString& strText, int &npos_start, CString& strFieldName) {
    ////////////////////////////////////////////////////////
    // formula field exchange
    //
    int nnewfieldstart_pos = -1;
    if ((nnewfieldstart_pos = strText.Find(_T("["), npos_start + 1)) < 0)
      return FALSE;

    for (int npos_end = nnewfieldstart_pos + 1; npos_end < strText.GetLength(); npos_end++)
    {
      if (strText.GetAt(npos_end) == ']') {
        if (npos_end > nnewfieldstart_pos) {
          //test [r.n]
          //0123456789
          strFieldName = strText.Mid(nnewfieldstart_pos + 1, (npos_end - (nnewfieldstart_pos + 1)));

          npos_start = npos_end;
          return TRUE;
        }
      }
    }
    ///////////////////////////////////////////////////////

    return FALSE;
  }
  */

  getSumField(index: number): reportSummationField {
    if (index >= 0 && index < this.summation_fields.length) {
      return this.summation_fields[index];
    }
    return null;
  }

  getSumFieldIndex(sTableColumn: string): number {
    // selection fields
    for (let ifld = 0; ifld < this.summation_fields.length; ifld++)
    {
      let fld = this.summation_fields[ifld];
      if (fld != null) {
        let sText: string = fld.getFullName();
        if (sText.toLowerCase() == sTableColumn.toLowerCase()) {
          return ifld;
        }
      }
    }
    return -1;
  }

  // Report Designer Overrides
  ///////////////////////////////////////////////////////////////////////////
  // selection
  // all fields to select from
  onGetSelectionField(fieldIndex: number): reportDataField { return null; }
  onGetSelectionFieldName(displayName: string): string { return ""; }

  // used to fill the report selection dialog
  onGetSelectionReport(reporttemplates: string[]): report[] { return []; }
  onGetCompanySelectionField(fieldIndex: number): reportCompanyField { return null; }
  onGetCompanySelectionFieldName(displayName: string): string { return ""; }
  onGetCustomSelectionField(fieldIndex: number): reportCustomField { return null; }
  onGetCustomSelectionFieldName(displayName: string): string { return ""; }

  ///////////////////////////////////////////////////////////////////////////
  // query
  // performs the database query
  onQueryRecord(fields: string[], filters: reportfilter[], preview: boolean = false): Array<Array<any>> { return null; }
  onQueryCompanyRecord(fields: string[]): string[] { return []; }
  // returns all data for a given record
  onGetRecord(recordIndex: number, fields: string[]): string[] { return []; }

  ///////////////////////////////////////////////////////////////////////////
  // user commands
  // called when user saves
  onSave(reportKey: string, reportName: string): boolean { return false; }
  // called when user saves
  onSaveAs(reportKey: string, reportName: string): boolean { return false; }
  // called when new report is requested
  onNew(reportKey: string, reportName: string): boolean { return false; }
  // called when user opens a report
  onOpen(reportKey: string, reportName: string): boolean {
    let fndRpt = this.reportTemplates.filter(t => t.report_key == reportKey);
    if (fndRpt.length == 0) return false;

    debugger;
    let atLeastOneSection = false, atLeastOneObject = false;
    /// sections
    for (let isecrec = 0; isecrec < fndRpt[0].RPTSECTIONS.length; isecrec++) {
      let storedSec = fndRpt[0].RPTSECTIONS[isecrec];
      let outputSec = this.getSectionByName(storedSec.getStringValue(storedSec.attributes, "SECTION"));
      if (outputSec) {
        outputSec.attributes = storedSec.attributes;
        atLeastOneSection = true;
      }
    }

    /// objects
    for (let iobj = 0; iobj < fndRpt[0].RPTOBJECTS.length; iobj++) {
      let obj = fndRpt[0].RPTOBJECTS[iobj];
      if (obj == null) continue;

      let repObj: reportObject = new reportObject(obj.attributes);
      let secName = repObj.getSection();
      let sec: reportSection = this.getSectionByName(secName);
      if (sec == null) return false;

      atLeastOneObject = true;
      switch (repObj.getType()) {
        case ReportObjectType.otObject: {
          sec.addObject(repObj);
          break;
        }
        case ReportObjectType.otTextField: {
          sec.addObject(new reportField(obj.attributes))[obj.gettablename().toLowerCase()] = obj[obj.gettablename().toLowerCase()];
          break;
        }
        case ReportObjectType.otDataField: {
          let repDatObj = new reportDataField(obj.attributes);
          let tcName = repDatObj.getFullName();
          if (this.outputColumnDefinitions[tcName] == null) {
            let cIndex = this.outputColumns.push(tcName) - 1;
            this.outputColumnDefinitions[tcName] = cIndex;
          }

          sec.addObject(repDatObj);
          break;
        }
        case ReportObjectType.otSystemField: {
          sec.addObject(new reportSystemField(obj.attributes));
          break;
        }
        case ReportObjectType.otParameterField: {
          sec.addObject(repObj);
          break;
        }
        case ReportObjectType.otFormulaField: {
          sec.addObject(new reportFormulaField(obj.attributes));
          break;
        }
        case ReportObjectType.otSummationField: {
          sec.addObject(new reportSummationField(obj.attributes));
          break;
        }
        case ReportObjectType.otPicture: {
          sec.addObject(new reportObject(obj.attributes));
          break;
        }
        case ReportObjectType.otGrouped: {
          sec.addObject(new reportObject(obj.attributes));
          break;
        }
        case ReportObjectType.otCompanyField: {
          sec.addObject(new reportCompanyField(obj.attributes));
          break;
        }
        case ReportObjectType.otCustomField: {
          sec.addObject(new reportCustomField(obj.attributes));
          break;
        }
      }
    }
    return atLeastOneSection || atLeastOneObject;
  }
  // called when user deletes a report
  onDelete(reportKey: string, reportName: string): boolean { return false; }
  // called when user deletes a report
  isDeleteAllowed(reportKey: string): boolean { return false; }
  // called when user trys to change a report
  isChangeAllowed(reportKey: string): boolean { return false; }
}
